<script>
export default {
    props: {
        errors: {
        type: Array,
            default(){
                return []
            }
        },
        showDismissibleAlert: {
            type: Boolean,
            default(){
                return false;
            }
        }
    }
}
</script>

<template>

    <div v-if="errors.length > 0">
        <b-alert v-for="error in errors" v-bind:key="error" 
            fade
            dismissible
            variant="danger"
            show
            v-model="showDismissibleAlert"
        >
            <div v-if="Array.isArray(error)">
                <p v-for="singleError in error" v-bind:key="singleError">{{ singleError }}</p>
            </div>
            <p v-else>{{ error }}</p>
        </b-alert>
    </div>

</template>